import { usePollsRef } from '@/api/pollsRef'

/**
 * Префикс всех polls-эндпоинтов бэка (ТЗ v3.1a §4.1).
 *
 * НЕ хардкодить `/api/max/polls` в fetch-вызовах — импортировать эту
 * константу. Один источник истины, один edit при пере-роутинге.
 *
 * Пример: `fetch(\`\${POLLS_API_PREFIX}/access\`)`.
 */
export const POLLS_API_PREFIX = '/api/max/polls'

/**
 * Видно ли пункт меню «Опросы» и доступны ли роуты `/polls*`.
 *
 * Source of truth — `POLLS_WHITELIST_USERS` env на бэке. F читает через
 * `GET /me/polls-ref` → `isPollsWhitelisted`. Локального списка нет — снят
 * 2026-07-27 после раскатки B-2 (contract-doc §2.6, §8).
 *
 * Возвращает `false` пока `/me/polls-ref` в полёте (`isLoading`) или ошибка —
 * pragmatic default: UI-guard закрыт до подтверждённой whitelisted-identity.
 *
 * Используется:
 * - в `DesktopShell` — скрыть/показать пункт меню
 * - в `App.tsx` — guard на роутах `/polls*` (редирект на `/dashboard` если false)
 * - **внутри тела React Query hooks** для `/api/max/polls/*` fetch'ей (правило §7.5 #1):
 *   `useQuery({ enabled: allowed && ..., queryFn: ... })`.
 *   Без gate внутри hooks фетч исполнится в `DesktopShell`/`ChannelProvider`
 *   для всех LK-юзеров и упадёт 404 → `Sentry.ErrorBoundary` рисует
 *   `ServerErrorState` (audit critical #6 «gate leak via ChannelProvider fetch»).
 */
export function usePollsAccess(): boolean {
  const { data } = usePollsRef()
  return data?.isPollsWhitelisted === true
}
